import { ReactElement, ReactNode } from 'react';
import { Typography } from '@cars4ever/public-ui';
import classNames from 'classnames';

import styles from './styles.module.scss';

export interface IResponsePageTemplateProps {
  Logo: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
  logoWrapperClassName?: string;
}

const ResponsePageTemplate = ({ className, logoWrapperClassName, Logo, title, description }: IResponsePageTemplateProps): ReactElement => (
  <div className={classNames(styles.responsePage, className)}>
    <div className={classNames(styles.logoWrapper, logoWrapperClassName)}>
      {Logo}
    </div>

    <Typography
      variant="subtitle1"
      className={styles.title}
      component="div"
    >
      {title}
    </Typography>

    {!!description && (
      <Typography
        className={styles.description}
        variant="body1"
        component="div"
      >
        {description}
      </Typography>
    )}
  </div>
);

export default ResponsePageTemplate;
